"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PictureDestinationInfo = void 0;
var enums_1 = require("../../destination/utils/enums");
var enums_2 = require("../enums");
var shape_properties_info_1 = require("../shape/shape-properties-info");
var PictureDestinationInfo = (function () {
    function PictureDestinationInfo() {
        this.pictureSourceType = enums_1.PictureSourceType.WindowsBmp;
        this.wmfMapMode = enums_2.Win32MapMode.Text;
        this.bmpBitsPerPixel = 1;
        this.bmpColorPlanes = 1;
        this.pictureWidth = -1;
        this.pictureHeight = -1;
        this.desiredPictureWidth = -1;
        this.desiredPictureHeight = -1;
        this.scaleX = 100;
        this.scaleY = 100;
        this.imageUri = "";
        this.leftCrop = 0;
        this.topCrop = 0;
        this.rightCrop = 0;
        this.bottomCrop = 0;
        this.dataStream = [];
        this.properties = new shape_properties_info_1.RtfShapePropertiesInfo();
    }
    Object.defineProperty(PictureDestinationInfo.prototype, "dataCrc32", {
        get: function () { return 0; },
        enumerable: false,
        configurable: true
    });
    return PictureDestinationInfo;
}());
exports.PictureDestinationInfo = PictureDestinationInfo;
